
import { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import FullScreenDialogTicket from 'src/pages/components-overview/material-ui/dialog/FullScreenDialogTicket';
import { isAdminUser } from '../../../../utils/adminUserTypes';
import { useTheme } from '@material-ui/core/styles'
import { experimentalStyled as styled } from '@material-ui/core/styles'
import {
  Container, Grid, IconButton,
  Stack, Box, Button, TableRow,
  TableBody, Checkbox, Card,
  TableCell, Typography,
  TableContainer, Table, TablePagination,
  AvatarGroup,
  Tooltip,
  Avatar,
  Autocomplete,
  TextField,
  Alert,
  DialogContent,
  DialogTitle,
  Dialog,
  Divider,
  CircularProgress,
} from '@material-ui/core';

// routes
import { PATH_DASHBOARD } from 'src/routes/paths';
// components
import Scrollbar from 'src/components/Scrollbar';
import { UserListHead, UserMoreMenu } from '../../user/list';
import Label from 'src/components/Label';
import { filter } from 'lodash';
import SearchNotFound from 'src/components/SearchNotFound';
import ProfileTicketsToolbar from 'src/components/_dashboard/user/list/ProfileTicketsToolbar';
import ConfirmationPopup from 'src/components/confirmationPopup';
import { REST_API_END_POINT, TICKET_PREFIX } from 'src/constants/Defaultvalues';
import axios from 'axios'
import { useSnackbar } from 'notistack';
import moment from 'moment';
import Modal from '../../blog/ProjectModel';
import { MapControlScale } from 'src/components/map';
import { MobileDateRangePicker } from '@material-ui/lab';
import NoteSticky from './StickyNote';
import { MIconButton } from 'src/components/@material-extend';
import DailyTicketSummary from './dailyTicketSummary';
import { Toolbar } from '@mui/material';
import { Close, ArrowBackIos, ArrowForwardIos } from '@material-ui/icons';
import TicketStatus from '../../user/AddTicketStatus';
import useTableMaxHeight from 'src/hooks/useTableMaxHeight';

const TABLE_HEAD = [
  { id: '', label: '', alignRight: false },
  { id: 'ID', label: 'ID', alignRight: false },
  { id: 'name', label: 'Tickets', alignRight: false },
  // { id: 'module_name', label: 'Module', alignRight: false },
  // { id: 'timestamp', label: 'Created At', alignRight: false },
  { id: 'Priority', label: 'Priority', alignRight: false },
  { id: 'start_date', label: 'Start Date', alignRight: false },
  { id: 'created_on', label: 'Created On', alignRight: false },
  { id: 'due_date', label: 'Due Date', alignRight: false },
  { id: 'created_by', label: 'Created By', alignRight: false },
  // { id: 'taskMembers', label: 'Assignee', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: '', label: '', alignRight: false },
  { id: '', label: '', alignRight: false },
]
const TicketPriority = [
  { value: 'High', id: 1 },
  { value: 'Medium', id: 2 },
  { value: 'Low', id: 3 },
  { value: 'Escalated', id: 4 },
]

const TicketTypeOptions = [
  { id: 1, value: 'Bug' },
  { id: 2, value: 'Story' },
  { id: 3, value: 'Task' }
];

// Alphanumeric comparison helper function (natural sort)
function alphanumericCompare(str1, str2) {
  const normalize = (str) => {
    if (str === null || str === undefined) return '';
    // Strip leading and trailing quotes before comparison
    let normalized = str.toString().trim();
    // Remove leading and trailing quotes (both single and double)
    normalized = normalized.replace(/^["']+|["']+$/g, '');
    return normalized;
  };

  const a = normalize(str1);
  const b = normalize(str2);

  // Split into parts: strings and numbers
  const partsA = a.match(/(\d+|\D+)/g) || [];
  const partsB = b.match(/(\d+|\D+)/g) || [];

  // Compare each part
  const minLength = Math.min(partsA.length, partsB.length);
  for (let i = 0; i < minLength; i++) {
    const partA = partsA[i];
    const partB = partsB[i];

    // If both parts are numbers, compare numerically
    if (/^\d+$/.test(partA) && /^\d+$/.test(partB)) {
      const numA = parseInt(partA, 10);
      const numB = parseInt(partB, 10);
      if (numA !== numB) {
        return numA - numB;
      }
    } else {
      // Otherwise, compare as strings (case-insensitive)
      const strCompare = partA.localeCompare(partB, undefined, { sensitivity: 'base' });
      if (strCompare !== 0) {
        return strCompare;
      }
    }
  }

  // If all parts are equal, shorter string comes first
  return partsA.length - partsB.length;
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// function applySortFilter(array, comparator, query,status,selectedModule ) {
//   if (!Array.isArray(array)) {
//     return [];
//   }

//   const stabilizedThis = array?.map((el, index) => [el, index]);
//   stabilizedThis?.sort((a, b) => {
//     const order = comparator(a[0], b[0]);
//     if (order !== 0) return order;
//     return a[1] - b[1];
//   });

//   if (query) {
//     return filter(array, (_user) => 
//       _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
//     (`SW-${_user.ID}`.toLowerCase().indexOf(query.toLowerCase()) !== -1)
//   );
//   }
//   if(status){
//     return filter(array,(user)=> user.status === status)
//    }

//      // Apply module filter
//   if (selectedModule) {
//     return filter(array, (user) => user.module_name == selectedModule.module_name);
//   }


//   return stabilizedThis?.map((el) => el[0]) || [];
// }

// Helper function to apply all filters except status filter (for count calculations)
function applyFiltersWithoutStatus(array, query, selectedModule, dateRange, selectedPriority, selectedTicketType) {
  if (!Array.isArray(array)) {
    return [];
  }

  let filteredArray = array;

  // Apply search query filter
  if (query) {
    const lowerQuery = query.toString().toLowerCase().trim();
    filteredArray = filteredArray.filter((_user) => {
      const nameMatch = (_user.name || '').toLowerCase().includes(lowerQuery);
      const idMatch = (`${TICKET_PREFIX}${_user.ID}` || '').toLowerCase().includes(lowerQuery);
      const descriptionMatch = (_user.description || '').toLowerCase().includes(lowerQuery);
      return nameMatch || idMatch || descriptionMatch;
    });
  }

  // Apply module filter
  if (selectedModule) {
    filteredArray = filter(filteredArray, (user) => user.module_name === selectedModule.module_name);
  }

  // Apply priority filter
  if (selectedPriority) {
    filteredArray = filter(filteredArray, (user) => user.priority === selectedPriority.id);
  }

  // Apply ticket type filter
  if (selectedTicketType) {
    filteredArray = filter(filteredArray, (user) => user.ticket_type === selectedTicketType.id);
  }

  // Apply date range filter
  if (dateRange && (dateRange[0] || dateRange[1])) {
    const [start, end] = dateRange;
    filteredArray = filteredArray.filter(user => {
      const createdAt = moment.unix(user.timestamp);
      const dueAt = moment.unix(user.due_date);
      const isCreatedInRange = start && end ? createdAt.isBetween(start, end, 'day', '[]') : true;
      const isDueInRange = start && end ? dueAt.isBetween(start, end, 'day', '[]') : true;
      return isCreatedInRange || isDueInRange;
    });
  }

  return filteredArray;
}

function applySortFilter(array, comparator, query, status, selectedModule, dateRange, selectedPriority,selectedTicketType) {
  if (!Array.isArray(array)) {
    return [];
  }

  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  // Apply all filters together
  let filteredArray = array;

  // Apply search query filter
  // if (query) {
  //   const lowerQuery = query.toString().toLowerCase().trim();; 
  //   filteredArray = filter(filteredArray, (_user) =>
  //     _user.name.toLowerCase().includes(query.toLowerCase()) ||
  //     `SW-${_user.ID}`.toLowerCase().includes(query.toLowerCase()) ||
  //     (_user.description || '').toLowerCase().includes(lowerQuery)
  //   );
  // }
  if (query) {
    const lowerQuery = query.toString().toLowerCase().trim();

    filteredArray = filteredArray.filter((_user) => {
      const nameMatch = (_user.name || '').toLowerCase().includes(lowerQuery);
      const idMatch = (`${TICKET_PREFIX}${_user.ID}` || '').toLowerCase().includes(lowerQuery);
      const descriptionMatch = (_user.description || '').toLowerCase().includes(lowerQuery);
      // const descriptionMatch = (_user.description || '').toLowerCase().includes(query.toLowerCase());

      return nameMatch || idMatch || descriptionMatch;
    });
  }

  // Apply status filter
  if (status !== null && status !== undefined) {
    filteredArray = filter(filteredArray, (user) => {
      // Handle both string and number comparisons
      return Number(user.status) === Number(status);
    });
  }

  // Apply module filter
  if (selectedModule) {
    filteredArray = filter(filteredArray, (user) => user.module_name === selectedModule.module_name);
  }
  if (selectedPriority) {
    console.log('selectedPriority22222222222222', selectedPriority)
    console.log('selectedPriority22222222222222', filteredArray)

    filteredArray = filter(filteredArray, (user) => user.priority === selectedPriority.id);
  }

  if (selectedTicketType) {
    filteredArray = filter(filteredArray, (user) => user.ticket_type === selectedTicketType.id);
  }

  // ⬇️ ADD DATE FILTER RIGHT BELOW THIS LINE
  if (dateRange && (dateRange[0] || dateRange[1])) {
    const [start, end] = dateRange;
    filteredArray = filteredArray.filter(user => {
      const createdAt = moment.unix(user.timestamp);
      const dueAt = moment.unix(user.due_date);
      const isCreatedInRange = start && end ? createdAt.isBetween(start, end, 'day', '[]') : true;
      const isDueInRange = start && end ? dueAt.isBetween(start, end, 'day', '[]') : true;
      return isCreatedInRange || isDueInRange;
    });
  }

  return stabilizedThis
    ?.filter(([el]) => filteredArray.includes(el))
    .map((el) => el[0]) || [];
}

const statusStyles = {
  1: { background: '#007bff', color: '#ffffff' }, // 🔵 New (updated)
  21: { background: '#ffc107', color: '#000000' }, // ❓ Clarification Needed
  6: { background: '#5bc0de', color: '#000000' }, // Assigned
  2: { background: '#0275d8', color: '#ffffff' }, // In Progress
  7: { background: '#f0ad4e', color: '#000000' }, // Waiting for Development
  8: { background: '#e38602', color: '#000000' }, // In Development
  9: { background: '#6c757d', color: '#ffffff' }, // Sent to QA
  10: { background: '#20c997', color: '#000000' }, // QA in Progress
  11: { background: '#d9534f', color: '#ffffff' }, // QA Failed
  12: { background: '#5cb85c', color: '#ffffff' }, // QA Passed
  14: { background: '#f7b731', color: '#000000' }, // Waiting for Client
  18: { background: '#5cb85c', color: '#000000' }, // Client approved
  20: { background: '#ff4757', color: '#ffffff' }, // Client Rejected
  15: { background: '#f39c12', color: '#000000' }, // Changes Requested
  13: { background: '#0275d8', color: '#ffffff' }, // Moved to Prod
  4: { background: '#dc3545', color: '#ffffff' }, // Re-opened
  16: { background: '#6f42c1', color: '#ffffff' }, // Escalated
  3: { background: '#28a745', color: '#ffffff' }, // Completed
  5: { background: '#c9302c', color: '#ffffff' }, // Cancelled
  17: { background: '#adb5bd', color: '#000000' }, // On Hold
  19: { background: '#212529', color: '#ffffff' }, // closed
};
export default function SupportTickets({ isLoading, tickets, buttonStatus, setButtonStatus, setRefresh, refresh, fromClient, openStickyDialog, setOpenStickyDialog, stickyContent, setStickyContent, stickyNoteId, setStickyNoteId, refreshSticky, setRefreshSticky, fetchStickyNote, userName, updatedName, addedOn, updatedOn, totalCount, page, setPage, rowsPerPage, setRowsPerPage, filters, setFilters, fetchAllTickets, statusCounts, totalCountAll, searchInput, setSearchInput }) {
  const navigate = useNavigate()
  const userSession = JSON.parse(localStorage.getItem('user'))
  const theme = useTheme()
  const { enqueueSnackbar } = useSnackbar()
  const [order, setOrder] = useState('desc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('ID');
  const [openDelete, setOpenDelete] = useState({ id: null, type: false })
  const [opens, setOpens] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null)
  const [modules, setModules] = useState(null)
  const [ticketSummaryData, setTicketSummaryData] = useState([]);
  const today = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  // Fetch all tickets updated today for summary (independent of pagination)
  const fetchTodayTicketsSummary = async () => {
    try {
      const res = await axios.post(`${REST_API_END_POINT}tickets/get-all-tickets`, {
        permission: userSession.user_permissions, 
        userId: userSession.user_id, 
        userType: userSession.user_type,
        page: 1,
        limit: 10000, // Very high limit to get all tickets for summary
        search: '',
        status: null,
        module: null,
        priority: null,
        ticket_type: null,
        dateRange: null // No date filter - we'll filter by status_updated on frontend
      });
      
      const allTickets = res?.data?.data?.task || [];
      const startOfTodayUnix = moment().startOf('day').unix();
      const endOfTodayUnix = moment().endOf('day').unix();
      
      // Filter tickets that were updated today (by status_updated field)
      const filteredTickets = allTickets.filter((ticket) => {
        if (!ticket.status_updated) return false;
        const updatedUnix = ticket.status_updated;
        return updatedUnix >= startOfTodayUnix && updatedUnix <= endOfTodayUnix;
      });
      
      setTicketSummaryData(filteredTickets);
    } catch (error) {
      console.error('Error fetching today tickets summary:', error);
      setTicketSummaryData([]);
    }
  };

  useEffect(() => {
    fetchTodayTicketsSummary();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh])

  const [openSummary, setOpenSummary] = useState(false);
  const [openTicketDialog, setOpenTicketDialog] = useState(false);
  const [selectedTicketId, setSelectedTicketId] = useState(null);
  const [selectedTicketName, setSelectedTicketName] = useState('');
  const [hasDataChanged, setHasDataChanged] = useState(false);
  const tableContainerRef = useRef(null);

  const tableMaxHeight = useTableMaxHeight(
    tableContainerRef,
    [isLoading, tickets?.length, rowsPerPage, page, filters?.status, filters?.search]
  );

  const handleScrollLeft = () => {
    tableContainerRef.current.scrollTo({
      left: 0,
      behavior: 'smooth'
    });
  };
  
  const handleScrollRight = () => {
    tableContainerRef.current.scrollTo({
      left: tableContainerRef.current.scrollWidth,
      behavior: 'smooth'
    });
  };

  const fetchAllMembers = async () => {
    try {
      axios
        .post(`${REST_API_END_POINT}tickets/get-team-data`)
        .then((res) => {
          if (res.data.status === 1) {
            // Sort modules alphanumerically by module_name
            const sortedModules = [...(res.data.Modules || [])].sort((a, b) => 
              alphanumericCompare(a?.module_name || '', b?.module_name || '')
            );
            setModules(sortedModules)
            console.log('ModulesModulesModules', sortedModules)

          } else {
            setMembers([])
          }
        })
        .catch((error) => {
          console.log(error)
        })
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    fetchAllMembers()
  }, [])

  const handleOpens = (data) => {
    console.log('Avatar clicked');
    setOpens(true);
    setSelectedRow(data)
  };

  const handleCloses = () => {
    console.log('close clicked');
    setOpens(false);
    setSelectedRow(null)

  };

  const handleOpenTicketDialog = (ticketId, ticketName) => {
    setSelectedTicketId(ticketId);
    setSelectedTicketName(ticketName);
    setOpenTicketDialog(true);
    setHasDataChanged(false); // Reset data change flag when opening dialog
  };

  const handleDataChange = () => {
    setHasDataChanged(true);
  };

  const handleCloseTicketDialog = () => {
    setOpenTicketDialog(false);
    setSelectedTicketId(null);
    setSelectedTicketName('');
    // Clear localStorage when dialog is closed
    localStorage.removeItem('ticketId');
    localStorage.removeItem('ticketName');
    localStorage.removeItem('ticketOpenDialog');
    
    // Always refresh the table when dialog closes to ensure latest data
    // This handles cases like ticket deletion where immediate refresh is needed
    setRefresh(prev => !prev);
    setHasDataChanged(false);
  };

  useEffect(() => {
    if (localStorage.getItem('refreshTickets') === 'true') {
      setRefresh(prev => !prev);          // ✅ trigger refresh
      localStorage.removeItem('refreshTickets');  // ✅ clean up the flag
    }
    
    // Check if dialog was open before refresh
    if (localStorage.getItem('ticketOpenDialog') === 'true') {
      const savedTicketId = localStorage.getItem('ticketId');
      const savedTicketName = localStorage.getItem('ticketName');
      if (savedTicketId) {
        setSelectedTicketId(savedTicketId);
        setSelectedTicketName(savedTicketName || '');
        setOpenTicketDialog(true);
      }
    }
  }, []);

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = tickets?.map((n) => n.ID);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected?.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage + 1); // Backend uses 1-based pagination
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1); // Reset to first page
  };
  const DeleteTicket = async () => {
    try {
      let res = await axios.post(`${REST_API_END_POINT}tickets/delete-ticket`, {
        taskId: openDelete.id,
        userId: userSession.user_id,
      })
      if (res.data.status == 1) {
        enqueueSnackbar(res.data.message, { variant: 'success' })
        setOpenDelete({ id: null, type: false })
        setRefresh(!refresh)
      } else {
        enqueueSnackbar('failed to delete ticket', { variant: 'error' })
        setOpenDelete({ id: null, type: false })
      }
      setDelPopup(!delPopup)
      setIsOpen(!open)
    } catch (error) {
      console.log(error, 'error in deleting ticket')
    }
  }
  const handleFilterByName = (event) => {
    const searchValue = event.target.value;
    if (setSearchInput) {
      setSearchInput(searchValue);
    } else {
      // Fallback if setSearchInput is not provided
      setFilters({ ...filters, search: searchValue });
    }
    setPage(1); // Reset to first page when filtering
  };

  // Apply sorting only (filtering is done on backend)
  const sortedTickets = tickets ? [...tickets].sort(getComparator(order, orderBy)) : [];
  const filteredUsers = sortedTickets;
  const isUserNotFound = !isLoading && filteredUsers?.length === 0;
  
  // Calculate empty rows for visual consistency (not needed for pagination since backend handles it)
  const emptyRows = rowsPerPage - (filteredUsers?.length || 0);
  return (
    <Card>
      {/* <Scrollbar> */}
      {ticketSummaryData && <DailyTicketSummary ticketSummaryData={ticketSummaryData} />}
      {/* </Scrollbar> */}
      <Divider sx={{ color: 'white' }} />
      <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", }}>
        <Box sx={{ display: "flex", }}>
          <ProfileTicketsToolbar numSelected={selected.length} filterName={searchInput !== undefined ? searchInput : (filters.search || '')} onFilterName={handleFilterByName} />
          <Box sx={{ mt: 2.5, display: 'flex', alignItems: 'flex-start', }} gap={2} flexDirection="row">
            <Autocomplete
              sx={{ width: 240 }}
              options={(modules || []).sort((a, b) => 
                alphanumericCompare(a?.module_name || '', b?.module_name || '')
              )}
              getOptionLabel={(option) => option.module_name}
              value={filters.module ? modules?.find(m => m.id === filters.module) || null : null}
              onChange={(event, newValue) => {
                setFilters({ ...filters, module: newValue?.id || null });
                setPage(1);
              }}
              renderInput={(params) => (
                <TextField {...params} label="Select Module" variant="outlined" />
              )}
              isOptionEqualToValue={(option, value) => option.id === value.id}
            />
 <Autocomplete
          sx={{ width: 240 }}
          options={[{ label: 'All', value: null }, ...TicketStatus]}
          getOptionLabel={(option) => {
            if (!option) return '';
            // For the selected value, show only the label without count
            const isSelected = (buttonStatus === null || buttonStatus === undefined) 
              ? (option.value === null || option.value === undefined)
              : (Number(option.value) === Number(buttonStatus));
            
            if (isSelected) {
              return option.label;
            }
            
            // Get count from backend statusCounts
            const ticketCount =
              option.value === null || option.value === undefined
                ? totalCountAll || 0
                : statusCounts?.[option.value] || 0;
            return `${option.label} (${ticketCount})`;
          }}
          value={
            buttonStatus === null || buttonStatus === undefined
              ? { label: 'All', value: null }
              : TicketStatus.find((s) => s.value === buttonStatus) || { label: 'All', value: null }
          }
          onChange={(event, newValue) => {
            if (setButtonStatus) {
              const newStatus = newValue?.value ?? null;
              setButtonStatus(newStatus);
              setFilters({ ...filters, status: newStatus });
              // Force page reset to trigger fetch
              if (page === 1) {
                // If already on page 1, trigger fetch directly
                fetchAllTickets(1, rowsPerPage, { ...filters, status: newStatus });
              } else {
                setPage(1);
              }
            }
          }}
          renderInput={(params) => (
            <TextField {...params} label="Filter by Status" variant="outlined" />
          )}
          renderOption={(props, option) => {
            if (!option) return null;
            // Get count from backend statusCounts
            const ticketCount =
              option.value === null || option.value === undefined
                ? totalCountAll || 0
                : statusCounts?.[option.value] || 0;
            return (
              <Box component="li" {...props} key={option.value ?? 'all'}>
                {option.label} ({ticketCount})
              </Box>
            );
          }}
          isOptionEqualToValue={(option, value) => {
            if (!option || !value) return false;
            return option.value === value.value;
          }}
        />
            <Alert severity="info" sx={{ mb: 2, mx: 3, p: 1.1 }}>
              Showing {filteredUsers?.length || 0} results
            </Alert>
          </Box>
        </Box>
        {/* <><MIconButton onClick={()=>{setOpenSummary(true);}}><Tooltip title='Daily Ticket Summary'><Stack className='twemoji--clipboard'/></Tooltip></MIconButton></> */}
        <Modal
          modalTitle={`🗓️ Daily Ticket Summary - [Date: ${today}]`}
          open={openSummary}
          handleClose={() => setOpenSummary(false)}
          width={600}>
          <DailyTicketSummary ticketSummaryData={ticketSummaryData} />
        </Modal>
        <Dialog
          open={openStickyDialog}
          onClose={() => setOpenStickyDialog(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={{ pl: 2.4, pr: 3, pb: 2, pt: 2 }}>
            Sticky Note
            <IconButton
              aria-label="close"
              onClick={() => setOpenStickyDialog(false)}
              sx={{
                position: 'absolute',
                right: 12,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <Close />
            </IconButton>
          </DialogTitle>
          <Box sx={{ minHeight: '500px', pl: 2, pr: 2, pb: 2 }}>
            <NoteSticky
              initialContent={stickyContent}
              noteId={stickyNoteId}
              onFullScreenClick={() => console.log('Full Screen Clicked')}
              onRefresh={() => setRefreshSticky(!refreshSticky)}
              setOpenStickyDialog={setOpenStickyDialog}
              fetchStickyNote={fetchStickyNote}
              userName={userName}
              updatedOn={updatedOn}
              addedOn={addedOn}
              updatedName={updatedName}
            />
          </Box>
        </Dialog>
      </Box>
      <Box sx={{ pl: 3, pb: 2, display: 'flex', alignItems: 'flex-start', gap: 2, flexDirection: 'row' }}>
       
        <Autocomplete
          sx={{ width: 240 }}
          options={TicketPriority}
          getOptionLabel={(option) => option.value}
          value={filters.priority ? TicketPriority.find(p => p.id === filters.priority) || null : null}
          onChange={(event, newValue) => {
            setFilters({ ...filters, priority: newValue?.id || null });
            setPage(1);
          }}
          renderInput={(params) => (
            <TextField {...params} label="Select Priority" variant="outlined" />
          )}
          isOptionEqualToValue={(option, value) => option.id === value.id}
        />
        <Autocomplete
          sx={{ width: 240 }}
          options={TicketTypeOptions}
          getOptionLabel={(option) => option.value}
          value={filters.ticket_type ? TicketTypeOptions.find(t => t.id === filters.ticket_type) || null : null}
          onChange={(event, newValue) => {
            setFilters({ ...filters, ticket_type: newValue?.id || null });
            setPage(1);
          }}
          renderInput={(params) => (
            <TextField {...params} label="Select Ticket Type" variant="outlined" />
          )}
          isOptionEqualToValue={(option, value) => option.id === value.id}
        />
        <MobileDateRangePicker
          startText="Start Date"
          endText="End Date"
          value={filters.dateRange || [null, null]}
          onChange={(newValue) => {
            setFilters({ ...filters, dateRange: newValue });
            setPage(1);
          }}
          renderInput={(startProps, endProps) => (
            <>
              <TextField
                {...startProps}
                helperText={false}
                InputProps={{
                  ...startProps.InputProps,
                  endAdornment: (
                    <>
                      {filters.dateRange?.[0] && (
                        <Tooltip title={'Refresh Field'}>
                          <IconButton
                            onClick={() => setFilters({ ...filters, dateRange: [null, filters.dateRange?.[1] || null] })}
                          >
                            <i className="bitcoin-icons--refresh-filled" />
                          </IconButton>
                        </Tooltip>
                      )}
                      {startProps.InputProps?.endAdornment}
                    </>
                  )
                }}
              />
              <Box sx={{ mx: 1 }}> - </Box>
              <TextField
                {...endProps}
                helperText={false}
                InputProps={{
                  ...endProps.InputProps,
                  endAdornment: (
                    <>
                      {filters.dateRange?.[1] && (
                        <Tooltip title={'Refresh Field'}>
                          <IconButton
                            onClick={() => setFilters({ ...filters, dateRange: [filters.dateRange?.[0] || null, null] })}
                          >
                            <i className="bitcoin-icons--refresh-filled" />
                          </IconButton>
                        </Tooltip>
                      )}
                      {endProps.InputProps?.endAdornment}
                    </>
                  )
                }}
              />
            </>
          )}
        />
      </Box>

      <Scrollbar>
        <TableContainer 
          ref={tableContainerRef}
          sx={{
            minWidth: 800,
            whiteSpace: "nowrap",
            overflowX: "auto",
            overflowY: "auto",
            maxHeight: tableMaxHeight,
            '&::-webkit-scrollbar': {
              width: '0.6em',
              height: '0.6em',
            },
            '&::-webkit-scrollbar-track': {
              background: '#1e1e1e',
              borderRadius: '4px',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#555',
              borderRadius: '6px',
              border: '2px solid #1e1e1e',
            },
            '&::-webkit-scrollbar-thumb:hover': {
              backgroundColor: '#888',
            },
          }}
        >
          <Table
            sx={{
              '& .MuiTableCell-head': {
                padding: '8px 16px',
                fontSize: '0.75rem',
                fontWeight: 600
              }
            }}
          >
            <UserListHead
              order={order}
              orderBy={orderBy}
              headLabel={TABLE_HEAD}
              rowCount={tickets?.length}
              numSelected={selected.length}
              onRequestSort={handleRequestSort}
              onSelectAllClick={handleSelectAllClick}
            />
            <TableBody>
              {isLoading ?
                <TableRow>
                  <TableCell colSpan={TABLE_HEAD?.length + 1}>
                    <Stack
                      alignItems="center"
                      justifyContent="center"
                      sx={{ minHeight: 300, width: '100%' }}
                    >
                      <CircularProgress color="primary" />
                    </Stack>
                  </TableCell>
                </TableRow>
                : <>
                  {filteredUsers?.map((row) => {
                    const { ID, name, project_name, status, timestamp, created_by, module_name, taskMembers, due_date, start_date, priority, ticket_type
                    } = row;
                    console.log('filteredUsersfilteredUsers', row)
                    const getStatusLabel = (status) => {
                      const match = TicketStatus.find((s) => s.value === status);
                      return match ? match.label : 'Unknown';
                    };
                    const isItemSelected = selected.indexOf(ID) !== -1;
                    // const priorityStatus = priority? TicketPriority.find((item) => item.id === priority) :null;
                    return (
                      <TableRow
                        hover
                        key={ID}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                        onClick={() => handleOpenTicketDialog(ID, name)}
                        sx={{ 
                          cursor: 'pointer',
                          backgroundColor: status === 21 ? 'rgba(255, 193, 7, 0.35)' : 'transparent',
                          '&:hover': {
                            backgroundColor: status === 21 ? 'rgba(255, 193, 7, 0.45) !important' : undefined
                          },
                          '& .MuiTableCell-root': {
                            padding: '8px 16px',
                            fontSize: '0.75rem',
                            height: 'auto'
                          }
                        }}
                      >
                        <TableCell padding="checkbox">
                          {/* <Checkbox checked={isItemSelected} onChange={(event) => handleClick(event, ID)} /> */}
                        </TableCell>

                        <TableCell padding="checkbox" onClick={(e) => {
                          e.stopPropagation();
                          handleScrollRight();
                        }}>
                          <IconButton sx={{ backgroundColor: theme.palette.divider, width: "35px", height: "35px" ,mr:1}}>
                            <ArrowForwardIos color="#ffffff" sx={{ width: "20px", fontSize: '1rem' }} />
                          </IconButton>
                        </TableCell>

                        <TableCell align="center" scope="row" padding="none">
                          <Stack direction='row' spacing={1} alignItems="center">
                            <Tooltip title='Ticket Type'>
                              <Label
                                variant='filled'
                                color={ticket_type === 1 ? 'error' : ticket_type === 2 ? 'purple' : ticket_type === 2 ? 'success' : 'success'}
                                sx={{
                                  width: 'fit-content',
                                  height: 'fit-content',
                                  minWidth: 0,
                                  p: '2px',
                                  borderRadius: '4px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  color: 'common.white',
                                  fontSize: '0.7rem'
                                }}
                              >
                                <Stack className={ticket_type === 1 ? 'ri--bug-fill-sm' : ticket_type === 2 ? 'cuida--bookmark-outline-sm' : ticket_type === 3 ? 'bx--task-sm' : 'bx--task-sm'} />
                              </Label>
                            </Tooltip> 
                            <Typography variant='subtitle2' sx={{ fontWeight: 500, whiteSpace: 'nowrap', fontSize: '0.75rem' }}>{TICKET_PREFIX}{ID}</Typography>
                          </Stack>
                        </TableCell>
                        <TableCell align="center" sx={{ cursor: 'pointer' }}
                        // onClick={() => navigate(PATH_DASHBOARD.crm.viewticket, { state: { id: ID } })}
                        >
                          <Tooltip title={name}>
                          <Typography variant='subtitle2' 
                          sx={{ fontWeight: 500, maxWidth: 100, overflow: 'hidden', textOverflow: 'ellipsis', 
                          whiteSpace: 'nowrap', fontSize: '0.75rem' }}>{name}</Typography>
                          </Tooltip>
                        </TableCell>
                        {/* <TableCell align="center">{module_name}</TableCell> */}
                        {console.log(moment.unix(timestamp).format('MM/DD/YYYY'))}
                        {/*<TableCell align="center">{timestamp ? moment.unix(timestamp).format('MM/DD/YYYY') : ''}</TableCell>*/}
                        <TableCell align="center">{
                          <Label sx={{ mt: 0.5, fontSize: '0.7rem', py: 0.25, px: 0.75 }}
                            variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                            color={priority === 1 ? 'error' : priority === 2 ? 'info' : 'success'} >
                            {priority === 1 ? 'High' : priority === 2 ? 'Medium' : priority === 4 ? 'Escalated' : 'Low'}
                          </Label>
                        }</TableCell>
                        <TableCell align="center" sx={{ fontSize: '0.75rem' }}>{start_date ? moment.unix(start_date).format('MM/DD/YYYY') : 'N/A'}</TableCell>
                        <TableCell align="center" sx={{ fontSize: '0.75rem' }}>{timestamp ? moment.unix(timestamp).format('MM/DD/YYYY') : 'N/A'}</TableCell>
                        <TableCell align="center" sx={{ fontSize: '0.75rem' }}>{due_date ? moment.unix(due_date).format('MM/DD/YYYY') : ''}</TableCell>
                        <TableCell align="center" sx={{ fontSize: '0.75rem' }}>{created_by}</TableCell>

                        {/* <TableCell align="center">

                          <AvatarGroup >
                            {taskMembers?.slice(0, 2).map((row) => (
                              <Tooltip key={row.ID} title={row.username || 'No Name Provided'}>
                                <Avatar src={row.profile_pic} alt={row.username} />
                              </Tooltip>
                            ))}
                            {taskMembers?.length > 2 && (
                              <Tooltip title="Show all">
                                <Avatar
                                  onClick={() => handleOpens(taskMembers)}
                                  style={{ cursor: 'pointer', backgroundColor: '#c8e6c9' }}
                                >
                                  +{taskMembers.length - 2}
                                </Avatar>
                              </Tooltip>
                            )}
                          </AvatarGroup>

                          {/* <Box sx={{width:"200px",height:"100px",position:"fixed",backgroundColor:"#fff",color:"#111"}}>
                        d
                        </Box> */}


                        {/* </TableCell>  */}

                        <TableCell align="center">
                          <Label
                            sx={{
                              backgroundColor: statusStyles[status]?.background || 'grey',
                              color: statusStyles[status]?.color || 'white',
                              fontSize: '0.7rem',
                              py: 0.25,
                              px: 0.75
                            }}
                          >
                            {getStatusLabel(status)}
                          </Label>
                        </TableCell>

                        <TableCell padding="checkbox" onClick={(e) => {
                          e.stopPropagation();
                          handleScrollLeft();
                        }}>
                          <IconButton sx={{ backgroundColor: theme.palette.divider, width: "35px", height: "35px" ,mr:1}}>
                            <ArrowBackIos color="#ffffff" sx={{ width: "20px", ml: 0.5, fontSize: '1rem' }} />
                          </IconButton>
                        </TableCell>

                        {/* {(!fromClient ||  userSession.isAdminUser (user_type)) && ( */}
                        {(isAdminUser (userSession.user_type) || userSession.user_type === 8) && (
                          <TableCell
                            onClick={(e) => {
                              // Prevent row's onClick from firing
                              e.stopPropagation();
                            }}
                          >
                            <UserMoreMenu
                              noEdit
                              onDelete={() => setOpenDelete({ id: ID, type: true })}
                            />
                          </TableCell>
                        )}

                      </TableRow>
                    );
                  })}
                </>}
              {emptyRows > 0 && (
                <TableRow style={{ height: 40 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
            {isUserNotFound && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                    <SearchNotFound searchQuery={filters.search || ''} />
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </Scrollbar>
      <ConfirmationPopup
        open={openDelete.type}
        message={'You want to delete this ticket'}
        handleClose={() => { setOpenDelete({ type: false, id: null }) }}
        handleClick={() => DeleteTicket()}
      />

      <Modal open={opens} handleClose={handleCloses} width={400}>
        <Box
        >
          <Typography variant="h6" gutterBottom>
            All Support Agents (Assignee's)
          </Typography>
          <Scrollbar sx={{ height: '350px' }}>
            <Stack spacing={2}>
              {selectedRow?.map((row) => (
                <Stack key={row.ID} direction="row" spacing={2} alignItems="center">
                  <Avatar src={row.profile_pic} alt={row.username} />
                  <Typography variant="body1">{row.username || 'No Name Provided'}</Typography>
                </Stack>
              ))}
            </Stack>
          </Scrollbar>
          <Button
            variant="contained"
            onClick={handleCloses}
            sx={{ mt: 2, display: 'block', ml: 'auto' }}
          >
            Close
          </Button>
        </Box>
      </Modal>

      <TablePagination
        rowsPerPageOptions={[25, 50, 100, 500]}
        component="div"
        count={totalCount || 0}
        rowsPerPage={rowsPerPage}
        page={page - 1}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

      <FullScreenDialogTicket
        open={openTicketDialog}
        setOpen={handleCloseTicketDialog}
        ticketId={selectedTicketId}
        ticketName={selectedTicketName}
        setRefreshTickets={setRefresh}
        refreshTickets={refresh}
        onDataChange={handleDataChange}
      />

    </Card>
  )
}